import Api from './Api';

class CustomerApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '', headers);
  }

  getInvoices = () => this.instance.get(`/Customer/Invoices`);

  getPayments = () => this.instance.get(`/Customer/Payments`);

  getPaymentMethods = () => this.instance.get(`/Customer/PaymentMethods`);

  attachPaymentMethods = (id: string) => this.instance.post(`/Customer/PaymentMethods/${id}`)

  getUpcomingInvoices = () => this.instance.get(`/Customer/Invoices/Upcoming`);

  getSubscriptions = () => this.instance.get(`/Customer/Subscriptions`);
}

export default CustomerApi;
